import React from 'react';
import { connect } from 'react-redux';

import getAvailableQualitiesForSlot from 'selectors/possessions/getAvailableQualitiesForSlot';
import EquippedGroupComponent from './EquippedGroupComponent';
import { IQuality } from 'types/qualities';
import { IAppState } from 'types/app';

function EquippedGroupContainer(props: Props) {
  const { availableQualities, isChanging, name } = props;
  return (
    <EquippedGroupComponent
      availableQualities={availableQualities}
      isChanging={isChanging}
      name={name}
    />
  );
}

EquippedGroupContainer.displayName = 'EquippedGroupContainer';

interface Props {
  availableQualities: IQuality[],
  isChanging: boolean,
  name: string,
}

const mapStateToProps: (state: IAppState, props: Props) => { availableQualities: IQuality[], isChanging: boolean } = (state: IAppState, props: Props) => ({
  availableQualities: getAvailableQualitiesForSlot(state, props),
  isChanging: state.outfit.isChanging,
});

export default connect(mapStateToProps)(EquippedGroupContainer);